(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["curatory-routine-context"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-routine-context]').forEach((context) => {
    if (context.dataset.routineReady === 'true') return;
    context.dataset.routineReady = 'true';
    const tabs = Array.from(context.querySelectorAll('[data-routine-tab]'));
    if (tabs.length < 2) return;
    const panels = Array.from(context.querySelectorAll('[data-routine-panel]'));
    context.classList.add('is-enhanced');
    const activate = (tab, moveFocus = false) => {
      const target = tab.dataset.routineTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.routinePanel === target));
      if (moveFocus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        activate(tabs[(index + direction + tabs.length) % tabs.length], true);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
